import { useState, useEffect } from "react";
import { Category } from "src/shared/services/interfacev2";
import { getCategory } from "src/shared/services/servicesv2";

export const useCategories = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchCategories = async () => {
    setLoading(true);

    try {
      const response = await getCategory();
      setCategories(response.data.categoryDetails);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // const refetchCategories = () => {
  //   fetchCategories();
  // };

  return { categories, loading, refetchCategories: fetchCategories };
};
